import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayError from 'shared/utils/displayError'

interface addAllSectionsProps {
  permissionId: number
}

const addAllSections = async (props: addAllSectionsProps) => {

  const formData = {
    permission_id: props.permissionId
  }

  const catchFunc = (err: AxiosError) => {
      displayError({errorMessage: err.message ?? 'An error occurred'})
  }

  const response = await axiosPost(apiUrls.permissionsToSections + '/' + apiUrls.actionAddAll, formData, catchFunc);

  return response.data === true
}

export default addAllSections
